/**
 * Set to true to disable PayPal login (e.g., while approval is pending).
 * Toggle back to false when PayPal integration is approved.
 */
export const LOGIN_DISABLED = true;

/**
 * Retired. /showcase is now the brand carousel (it was the Brands page) and
 * is always on; the separate Showcase page this used to hide
 * (pages/ShowcasePage.jsx) is no longer routed. Nothing reads this any more.
 */
export const SHOWCASE_ENABLED = false;

/**
 * Music is switched off for now: no header toggle, no floating note, no
 * per-brand-row toggle, and the <audio> element neither loads nor plays a
 * track. Flip to true to bring it all back.
 */
export const MUSIC_ENABLED = false;

/**
 * The header's music button on its own (the owner, 2026-10-17: "re add music
 * icon left of the currency"): the note in the bar, which plays and pauses
 * the site's tracks. The rest of the music above (floating note, per-brand
 * toggles) stays with MUSIC_ENABLED. Either flag turns the <audio> on.
 */
export const MUSIC_HEADER_ENABLED = true;

/**
 * The BRANDS hover menu in the desktop header is off for now: BRANDS is a
 * plain section link again and no brand list is fetched. The panel, its
 * glass styling and the hover handling are all still in place behind this,
 * so flipping to true brings it back as it was.
 */
export const BRANDS_MENU_ENABLED = false;

/**
 * The about paragraphs at the top of the site footer ("itrapswag is a curated
 * online clothing resale platform...") are off: the footer is its link line
 * alone. The copy and its styling are still in Footer.jsx and app.css, so
 * flipping this to true brings the block back, both rules and all.
 */
export const FOOTER_ABOUT_ENABLED = false;
